import script from "./CardProductCart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardProductCart.vue?vue&type=script&lang=ts&setup=true"

import "./CardProductCart.vue?vue&type=style&index=0&id=ba6c91e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba6c91e8"]])

export default __exports__